export default "__VITE_ASSET__DasEQE7X__"